export enum CustomFilterEventType {
    Save = 'Save',
    ClearModel = 'Clear',
}
